export default __webpack_public_path__ + "static/media/neuropeakLogo.fed6746f.png";